export enum NotificationCode {
  NEW_LIABILITY = 'NEW_LIABILITY',
  USER_PANEL_ACCESS_INVALID = 'USER_PANEL_ACCESS_INVALID',
  USER_PANEL_ACCESS_FOLLOW_UP_CREDENTIALS_REQUIRED = 'USER_PANEL_ACCESS_FOLLOW_UP_CREDENTIALS_REQUIRED',
  USER_PANEL_ACCESS_INVALID_FOLLOW_UP_CREDENTIALS = 'USER_PANEL_ACCESS_INVALID_FOLLOW_UP_CREDENTIALS',
  EMAIL_SOURCE_ENABLED = 'EMAIL_SOURCE_ENABLED',
  USER_PANEL_SOURCE_ENABLED = 'USER_PANEL_SOURCE_ENABLED',
  IDENTITY_VERIFIED = 'IDENTITY_VERIFIED',
  IDENTITY_VERIFICATION_FAILED = 'IDENTITY_VERIFICATION_FAILED',
  LIABILITY_AUTOMATIC_READING_READY = 'LIABILITY_AUTOMATIC_READING_READY',
  MODAL_CREATED = 'MODAL_CREATED',
}
